// components/WeatherInfo.jsx - Streamlined single-day weather display
import React from 'react';

const WeatherInfo = ({ weather }) => {
  if (!weather) {
    return (
      <div style={{
        backgroundColor: '#E2F1FD',
        borderLeft: '4px solid #3B9AE8',
        borderRadius: '0 8px 8px 0',
        padding: '16px',
        marginBottom: '16px'
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px', color: '#032B3A' }}>
          🌤️ Today's Weather
        </h3>
        <p style={{ color: '#5D757E', fontSize: '14px' }}>
          Weather data not available
        </p>
      </div>
    );
  }

  const { current, today } = weather;

  // Get weather icon URL from OpenWeather
  const iconUrl = current?.icon 
    ? `https://openweathermap.org/img/wn/${current.icon}@2x.png`
    : null;

  return (
    <div style={{
      backgroundColor: '#E2F1FD',
      borderLeft: '4px solid #3B9AE8',
      borderRadius: '0 8px 8px 0',
      padding: '16px',
      marginBottom: '16px'
    }}>
      <h3 style={{ 
        fontSize: '16px', 
        fontWeight: '600', 
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#032B3A'
      }}>
        🌤️ Today's Weather
      </h3>

      {/* Main Weather Display */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '12px'
      }}>
        {iconUrl && (
          <img 
            src={iconUrl} 
            alt={current.description}
            style={{ width: '64px', height: '64px' }}
          />
        )}
        <div>
          <div style={{ fontSize: '32px', fontWeight: '700', color: '#032B3A' }}>
            {current?.temp}°F
          </div>
          <div style={{ fontSize: '14px', color: '#233D48', textTransform: 'capitalize' }}>
            {current?.description}
          </div>
        </div>
      </div>

      {/* Weather Stats Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '8px'
      }}>
        <WeatherStat 
          label="High" 
          value={`${today?.high}°`}
          icon="🌡️"
        />
        <WeatherStat 
          label="Low" 
          value={`${today?.low}°`}
          icon="🌡️"
        />
        <WeatherStat 
          label="Wind" 
          value={`${current?.windSpeed} mph`}
          subValue={current?.windGust ? `gusts ${current.windGust}` : null}
          icon="💨"
        />
        <WeatherStat 
          label="Precip" 
          value={`${today?.precipitation}%`}
          icon="🌧️"
        />
      </div>
    </div>
  );
};

// Weather stat component
const WeatherStat = ({ label, value, subValue, icon }) => (
  <div style={{
    backgroundColor: 'white',
    borderRadius: '6px',
    padding: '8px',
    textAlign: 'center'
  }}>
    <div style={{ fontSize: '16px', marginBottom: '2px' }}>{icon}</div>
    <div style={{ fontSize: '14px', fontWeight: '600', color: '#032B3A' }}>
      {value}
    </div>
    <div style={{ fontSize: '11px', color: '#5D757E' }}>
      {label}
    </div>
    {subValue && (
      <div style={{ fontSize: '10px', color: '#9ca3af' }}>
        {subValue}
      </div>
    )}
  </div>
);

export default WeatherInfo;